/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   4/25/22
 */

import React from "react";
import {Divider, IconButton, Stack, Typography} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {Link} from "react-router-dom";
import SubscriptionForm from "./SubscriptionForm";
import {useSelector} from "react-redux";
import {State} from "../../state/store";

export default function NewSubscription() {

	const user = useSelector((s:State) => s.user);

	return (
		<Stack spacing={1} sx={{ p: 1 }}>
			<Stack direction={"row"} alignItems={"center"}>
				<IconButton size={"large"} to={"/notifications/events"} component={Link}>
					<ArrowBackIcon />
				</IconButton>
				<Stack>
					<Typography gutterBottom  variant="h4" sx={{ mb: 0, ml: 1 }}>
						New Event Notification
					</Typography>
				</Stack>
			</Stack>
			<Divider />
			<SubscriptionForm
				config={{
					types: ["calendar-event.created"],
					employeesFilter: [
						["+", "id", [user?.id as string]]
					]
				}}
			/>
		</Stack>
	);

}